module.exports = __webpack_public_path__ + "static/media/27.b90d23d9.png";